import { Component, OnInit } from '@angular/core';
import { NavigationService } from '@bo-client/core/navigation/navigation.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FooterMenu } from '@bo-client/core/navigation/footer-menu.definition';
import { Theme } from '@bo-client/shared/models/tenantDto';
import { AuthenticationService } from '@bo-client/core';

@Component({
  selector: 'app-footer-menu',
  templateUrl: './footer-menu.component.html',
  styleUrls: ['./footer-menu.component.scss']
})
export class FooterMenuComponent implements OnInit {
  private compUnsubs$ = new Subject<void>();
  public menu = FooterMenu;

  theme: Theme = new Theme();

  constructor(
    private navigationService: NavigationService,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit() {
    this.menu = FooterMenu;
  }

  ngOnDestroy() {
    this.compUnsubs$.next();
    this.compUnsubs$.complete();
  }
}
